import React from 'react';
import chooser from "../Assets/images/homepage_choose_png.png";
import "../Assets/styles/choose.css"
import { PiHandshakeLight } from "react-icons/pi";
import { GiPayMoney } from "react-icons/gi";
import { MdDevices } from "react-icons/md";
import { CiLock } from "react-icons/ci";

const Choose = () => {
  return (
    <>
        <div className="container-lg  choose">
            <div className="header" data-aos="fade-right" data-aos-duration="1000">
                <span>Best Offer</span> 
                <h3>Why Choose Us</h3>
            </div>
            {/* <div className="title">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incidiunt  labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p>
                <div className="bar"></div>
            </div> */}
            <div className="row align-items-center">
                <div className="col-lg-6">
                    <div className="choose-content" data-aos="fade-up" data-aos-duration="1000">
                        <div className="icon">
                            <PiHandshakeLight/>
                        </div>
                        <h3>We are Committed</h3>
                        <p>We're committed to guiding you through every stage, ensuring your journey is seamless from beginning to end.
                        </p>
                    </div>
                    <div className="choose-content" data-aos="fade-up" data-aos-duration="1000">
                        <div className="icon">
                        <GiPayMoney />
                        </div>
                        <h3>Cost Effective</h3>
                        <p>You won't need to worry about salaries or technical expenses. Our service streamlines development, saving you money while delivering top-notch results.</p>
                    </div>
                    <div className="choose-content" data-aos="fade-up" data-aos-duration="1000">
                        <div className="icon">
                        <MdDevices />
                        </div>
                        <h3>Quality Service</h3>
                        <p>With our expertise and dedication, we ensure exceptional results and client satisfaction every step of the way.</p>
                    </div>
                    <div className="choose-content" data-aos="fade-up" data-aos-duration="1000">
                        <div className="icon">
                            <CiLock/>
                        </div>
                        <h3>Keep Control</h3>
                        <p>While we provide support and expertise, you retain full ownership and decision-making authority, ensuring your vision remains intact.</p>
                    </div>
                </div>
                <div className="col-lg-6 choose-right" data-aos="fade-up" data-aos-duration="1000">
                    <div>
                        <img src={chooser} className="choose-image" alt="imageh"/>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default Choose